import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

export default async function fetchPredictions(
  address: string,
  lambdaUrl: string,
) {
  const apiUrl = `${lambdaUrl}${getEnvironmentVar('EXPO_GOOGLE_PLACES_API_BASE_URL')}/autocomplete/json?key=${getEnvironmentVar('EXPO_GOOGLE_GEOCODE_PLACES_API_KEY')}&input=${address}`;

  return unauthenticatedFetch(apiUrl, {
    method: 'POST',
  });
}
